import _ from "lodash";
import React from "react";
import { useIntl } from "react-intl";

export const SchedulesTimerRuns = (props) => {
  const { values = [], changeValues } = props;
  const intl = useIntl();
  return (
    <div>
      {_.map(values, (elem, index) => {
        return (
          <div className="row mb-1" key={index}>
            <div className="col-10">
              <div className="row">
                <div className="col">
                  <input
                    type="string"
                    name="runtime"
                    className="form-control"
                    placeholder={intl.formatMessage({
                      id: "OpenAI.Schedules.runtime",
                    })}
                    value={elem.runtime || ""}
                    onChange={({ target }) => {
                      Object.assign(values[index], { [target.name]: target.value });
                      changeValues(values);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="col text-right">
              <SchedulesTimerRuns.RemoveButton {...props} index={index} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

SchedulesTimerRuns.AddButton = (props) => {
  const { values = [], changeValues } = props;
  const addValue = () => {
    changeValues(values.concat([{}]));
  };
  return (
    <button className={`btn btn-success ${props.className}`} onClick={addValue}>
      <i className="fa fa-plus" />
    </button>
  );
};

SchedulesTimerRuns.RemoveButton = (props) => {
  const { values = [], changeValues } = props;
  const removeValue = () => {
    changeValues(values.filter((elem, index) => index !== props.index));
  };
  return (
    <button className={`btn btn-sm btn-danger`} onClick={removeValue}>
      <i className="fa fa-minus" />
    </button>
  );
};

export default SchedulesTimerRuns;
